import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  background-color: #fdfdff;\n  display: flex;\n  flex-direction: column;\n\n  div,\n  a,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p {\n    color: ",
        ";\n  }\n\n  @media (max-width: 1200px) {\n    padding: 0 20px;\n  }\n  @media (max-width: 768px) {\n    padding: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  font-size: 32px;\n  font-weight: bold;\n  text-align: center;\n  line-height: 1.5;\n  word-break: keep-all;\n  padding: 88px 0 80px;\n\n  &:nth-of-type(1) {\n    padding: 96px 0 64px;\n  }\n\n  span {\n    display: block;\n    font-size: 24px;\n    font-weight: normal;\n    line-height: 1.5;\n    margin-top: 36px;\n  }\n\n  @media (max-width: 1200px) {\n    font-size: 28px;\n    padding: 64px 0 48px;\n\n    span {\n      font-size: 22px;\n    }\n  }\n  @media (max-width: 768px) {\n    font-size: 22px;\n    padding: 48px 0 24px;\n\n    span {\n      font-size: 18px;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  img {\n    display: block;\n    width: 100%;\n    max-width: 914px;\n    margin: 0 auto;\n  }\n\n  .inner {\n    display: flex;\n    word-break: keep-all;\n    padding: 48px 64px 48px 56px;\n    margin-top: 112px;\n    background-color: rgba(255, 76, 17, 0.04);\n\n    .title {\n      width: 290px;\n      font-size: 24px;\n      font-weight: bold;\n      color: #ff4c11;\n      line-height: 1.35;\n\n      &:before {\n        display: inline-block;\n        content: '';\n        vertical-align: baseline;\n        width: 16px;\n        height: 16px;\n        margin-right: 16px;\n        border-radius: 50%;\n        background-color: #ff4c11;\n      }\n    }\n\n    .text {\n      flex: 1;\n      font-size: 24px;\n      color: ",
        ";\n      line-height: 1.5;\n    }\n\n    @media (max-width: 1200px) {\n      .title {\n        font-size: 22px;\n      }\n\n      .text {\n        font-size: 22px;\n      }\n    }\n    @media (max-width: 768px) {\n      display: block;\n      padding: 24px 48px 24px 36px;\n\n      .title {\n        font-size: 20px;\n\n        &:before {\n          vertical-align: middle;\n          width: 8px;\n          height: 8px;\n          margin-right: 8px;\n        }\n      }\n\n      .text {\n        font-size: 20px;\n        margin-top: 16px;\n      }\n    }\n    @media (max-width: 500px) {\n      padding: 24px;\n\n      .title {\n        font-size: 18px;\n      }\n\n      .text {\n        font-size: 16px;\n      }\n    }\n  }\n\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  position: relative;\n  margin-top: 104px;\n\n  &:before {\n    display: block;\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 200vw;\n    height: 100%;\n    background-color: #f0fafc;\n    z-index: 0;\n    transform: translateX(-50%);\n  }\n\n  & > * {\n    position: relative;\n    z-index: 1;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  padding-bottom: 140px;\n\n  .alice-carousel {\n    display: flex;\n    flex-wrap: wrap;\n\n    .alice-carousel__stage-item {\n      width: 100% !important;\n    }\n\n    div:nth-of-type(1) {\n      order: 2;\n    }\n\n    .alice-carousel__dots {\n      order: 1;\n      display: flex;\n      width: 100%;\n      height: 67px;\n      margin: 0 0 68px;\n      border-top: solid 2px ",
        ";\n      border-bottom: solid 2px ",
        ";\n\n      @media (max-width: 1200px) {\n        height: 56px;\n      }\n      @media (max-width: 768px) {\n      }\n      @media (max-width: 500px) {\n        margin-bottom: 24px;\n      }\n\n      .alice-carousel__dots-item {\n        flex: 1;\n        height: 100%;\n        font-size: 24px;\n        font-weight: normal;\n        color: ",
        ";\n        line-height: 65px;\n        background-color: transparent;\n\n        &.__active {\n          font-weight: bold;\n        }\n\n        &:nth-of-type(1):before {\n          content: '온라인 홍보';\n        }\n\n        &:nth-of-type(2):before {\n          content: '내 자료 보호';\n        }\n\n        &:nth-of-type(3):before {\n          content: '내 자료 판매';\n        }\n\n        @media (max-width: 1200px) {\n          font-size: 20px;\n          line-height: 52px;\n        }\n        @media (max-width: 768px) {\n          font-size: 16px;\n          line-height: 54px;\n        }\n      }\n    }\n\n    .alice-carousel__prev-btn,\n    .alice-carousel__next-btn {\n      top: 90%;\n      right: unset;\n      bottom: 0;\n    }\n\n    .alice-carousel__prev-btn {\n      left: calc(min(672px, 52%) + 88px);\n    }\n\n    .alice-carousel__next-btn {\n      left: calc(min(672px, 52%) + 148px);\n    }\n\n    @media (max-width: 1200px) {\n      .alice-carousel__prev-btn,\n      .alice-carousel__next-btn {\n        bottom: -24px;\n        top: 92%;\n      }\n\n      .alice-carousel__prev-btn {\n        left: calc(44% + 36px);\n      }\n\n      .alice-carousel__next-btn {\n        left: calc(44% + 96px);\n      }\n    }\n    @media (max-width: 768px) {\n      .alice-carousel__prev-btn,\n      .alice-carousel__next-btn {\n        bottom: -56px;\n        top: 106%;\n      }\n\n      .alice-carousel__prev-btn {\n        left: calc(36% + 16px);\n      }\n\n      .alice-carousel__next-btn {\n        left: calc(36% + 68px);\n      }\n    }\n    @media (max-width: 500px) {\n      .alice-carousel__prev-btn,\n      .alice-carousel__next-btn {\n        left: 0;\n        right: 0;\n        bottom: -56px;\n        margin: 0 auto;\n      }\n\n      .alice-carousel__prev-btn {\n        transform: translateX(calc(-50% - 8px));\n      }\n\n      .alice-carousel__next-btn {\n        transform: translateX(calc(50% + 8px));\n      }\n    }\n  }\n\n  @media (max-width: 500px) {\n    padding-bottom: 48px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  padding: 136px 0 156px;\n\n  .top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 36px;\n\n    .date {\n      font-size: 24px;\n      color: ",
        ";\n      line-height: 1.5;\n\n      &:before {\n        display: inline-block;\n        vertical-align: middle;\n        content: '';\n        width: 5px;\n        height: 5px;\n        margin: 0 12px;\n        border-radius: 50%;\n        background-color: ",
        ";\n      }\n    }\n\n    .text {\n      font-size: 16px;\n      color: #5f5f69;\n      line-height: 1.5;\n    }\n  }\n\n  @media (max-width: 1200px) {\n    .top {\n      display: block;\n      margin-bottom: 16px;\n\n      .date {\n        font-size: 18px;\n      }\n\n      .text {\n        font-size: 14px;\n        text-align: right;\n      }\n    }\n  }\n  @media (max-width: 768px) {\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  text-align: center;\n  padding: 72px 0;\n  background-color: #fdfdff;\n  border-bottom: solid 1px ",
        ";\n\n  .ant-btn {\n    height: auto;\n    border: solid 2px #002fa8;\n    border-radius: 0;\n    padding: 16px 88px 16px 50px;\n    transition: all 0.2s;\n    word-break: keep-all;\n\n    span {\n      font-size: 16px;\n      font-weight: bold;\n      line-height: 1.5;\n    }\n\n    .block_m {\n      display: none;\n\n      @media (max-width: 768px) {\n        //display: block;\n      }\n    }\n\n    &:before {\n      display: block;\n      content: '';\n      vertical-align: text-bottom;\n      position: absolute;\n      right: 50px;\n      top: 50%;\n      width: 24px;\n      height: 24px;\n      background: url('/static/assets/icon_outlink_white.svg') no-repeat 50% 50%;\n      background-size: contain;\n      transform: translateY(-50%);\n    }\n\n    @media (hover: hover) {\n      &:hover {\n        background-color: #113ac3;\n\n        span {\n          color: #fff;\n        }\n\n        &:before {\n          background-image: url('/static/assets/icon_outlink_white.svg');\n        }\n      }\n    }\n  }\n\n  @media (max-width: 1200px) {\n    margin: 0 -50px;\n  }\n  @media (max-width: 768px) {\n    padding: 48px 16px;\n    margin: 0;\n\n    .ant-btn {\n      width: 100%;\n      max-width: 100%;\n      height: auto;\n      min-height: 32px;\n      padding: 8px 44px 8px 16px;\n\n      &:before {\n        position: absolute;\n        top: 50%;\n        right: 16px;\n        vertical-align: middle;\n        transform: translateY(-50%);\n      }\n\n      span {\n        font-size: 14px;\n        white-space: pre-wrap;\n        word-break: keep-all;\n        vertical-align: middle;\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n\n  @media (max-width: 1200px) {\n    align-items: center;\n  }\n  @media (max-width: 768px) {\n    gap: 16px;\n    justify-content: center;\n  }\n  @media (max-width: 500px) {\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  img {\n    max-width: min(672px, 52%);\n\n    @media (max-width: 1200px) {\n      max-width: 44%;\n    }\n    @media (max-width: 768px) {\n      max-width: 36%;\n      margin: 0 auto;\n    }\n    @media (max-width: 500px) {\n      max-width: 70%;\n      margin: 0 15%;\n    }\n  }\n\n  .text-area {\n    flex: 1;\n    height: 100%;\n    padding-left: 88px;\n    padding-bottom: 120px;\n\n    .title {\n      font-size: 24px;\n      font-weight: bold;\n      color: ",
        ";\n      line-height: 1.35;\n    }\n\n    .desc {\n      font-size: 24px;\n      font-weight: normal;\n      color: ",
        ";\n      line-height: 1.5;\n      margin-top: 22px;\n    }\n\n    .copyright {\n      font-size: 20px;\n      font-weight: normal;\n      color: #5f5f69;\n      line-height: 1.5;\n      margin-top: 24px;\n    }\n\n    @media (max-width: 1200px) {\n      padding-left: 36px;\n      padding-bottom: 64px;\n\n      .title {\n        font-size: 22px;\n      }\n\n      .desc {\n        font-size: 22px;\n        word-break: keep-all;\n      }\n\n      .copyright {\n        font-size: 18px;\n      }\n    }\n    @media (max-width: 768px) {\n      padding: 0;\n\n      .title {\n        font-size: 18px;\n      }\n\n      .desc {\n        font-size: 18px;\n      }\n\n      .copyright {\n        font-size: 16px;\n      }\n    }\n    @media (max-width: 500px) {\n      padding-left: 8px;\n    }\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _tagged_template_literal([
        "\n  margin: -32px 0;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Container } from "@/components";
import { GenericPanelWithModal } from "@/components/GenericPanel";
import { HasContentsPopupWrapper } from "@/components/HasContentsPopupWrapper";
import { Panel } from "@/components/Panel";
import useRedirect from "@/hooks/useRedirect";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { SlideWrap } from "@/modules/landings/home/MainContainer/views/ProductRecommendSection";
import { ProtectionReportForm } from "@/modules/landings/protection/ProtectionReportForm";
import { WarningOutlined } from "@ant-design/icons";
import { action } from "@storybook/addon-actions";
import { themeGet } from "@styled-system/theme-get";
import { Button, Modal } from "antd";
import { observer } from "mobx-react-lite";
import Image from "next/image";
import { useRouter } from "next/router";
import AliceCarousel from "react-alice-carousel";
const Wrapper = styled.div.withConfig({
    componentId: "sc-b2591915-0"
})(_templateObject(), themeGet("text.0", "#1B1B29"));
const SectionHeader = styled.div.withConfig({
    componentId: "sc-b2591915-1"
})(_templateObject1());
const InfoBox = styled.div.withConfig({
    componentId: "sc-b2591915-2"
})(_templateObject2(), themeGet("text.0", "#1B1B29"));
const SecondSection = styled.div.withConfig({
    componentId: "sc-b2591915-3"
})(_templateObject3());
const StyledSlideWrap = styled(SlideWrap).withConfig({
    componentId: "sc-b2591915-4"
})(_templateObject4(), themeGet("primary.1", "#00BFC8"), themeGet("primary.1", "#00BFC8"), themeGet("primary.1", "#00BFC8"));
const PublisherArea = styled.div.withConfig({
    componentId: "sc-b2591915-5"
})(_templateObject5(), themeGet("color.0", "#1B1B29"), themeGet("color.0", "#1B1B29"));
export const CTASection = styled.div.withConfig({
    componentId: "sc-b2591915-6"
})(_templateObject6(), themeGet("border.1", "#E8E8EA"));
const CarouselItem = styled.div.withConfig({
    componentId: "sc-b2591915-7"
})(_templateObject7(), themeGet("primary.1", "#00BFC8"), themeGet("text.0", "#1B1B29"));
export const ProtectionReportFormWrapper = styled.div.withConfig({
    componentId: "sc-b2591915-8"
})(_templateObject8());
export const ProtectDescription = observer((param)=>{
    let { onClick , modalOpen , initialValues , onSubmit , publisherOptions , onSetImageFile , onSetPdfFile  } = param;
    const authStore = useAuthStore();
    const router = useRouter();
    const { redirectToLogin  } = useRedirect();
    const carouselItems = [
        {
            title: "온라인 홍보",
            desc: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    '"수업 영상을 유튜브에 올려도 문제 없어요. ',
                    /*#__PURE__*/ _jsx("br", {}),
                    '학원 홍보도 되고 수익 창출도 됩니다."'
                ]
            }),
            copyright: "유튜브 채널 : 아삭영어",
            img: "/static/assets/img-protection-1.png"
        },
        {
            title: "내 자료 보호",
            desc: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    '"공들여 만든 내 수업자료, ',
                    /*#__PURE__*/ _jsx("br", {}),
                    '이제 무단 배포되지 않도록 보호할 수 있어요."'
                ]
            }),
            copyright: "내신 수업자료 : 젠나 영어학원",
            img: "/static/assets/img-protection-2.png"
        },
        {
            title: "내 자료 판매",
            desc: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    '"전문성 인정받은 내신자료, ',
                    /*#__PURE__*/ _jsx("br", {}),
                    '정식 자료 마켓을 통하니까 전국에서 쓰이네요."'
                ]
            }),
            copyright: "전문 자료 저작자",
            img: "/static/assets/img-protection-3.png"
        }
    ];
    const renderItems = carouselItems.map((item)=>{
        return /*#__PURE__*/ _jsxs(CarouselItem, {
            children: [
                /*#__PURE__*/ _jsx(Image, {
                    src: item.img,
                    alt: "슬라이드 이미지",
                    width: 2016,
                    height: 1416
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-area",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "title",
                            children: item.title
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "desc",
                            children: item.desc
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "copyright",
                            children: item.copyright
                        })
                    ]
                })
            ]
        });
    });
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsxs(Container, {
                children: [
                    /*#__PURE__*/ _jsxs(SectionHeader, {
                        children: [
                            "R인증은 교육콘텐츠의 저작권 이용 자격을 식별하는 체계입니다.",
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    "출판사의 정식 이용 허락을 받은 ",
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "교재 기반의 검증된 수업과 수업자료에 발급됩니다."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(InfoBox, {
                        children: [
                            /*#__PURE__*/ _jsx(Image, {
                                src: "/static/assets/img_R_center.jpg",
                                alt: "저작권 이미지",
                                width: 914,
                                height: 796
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "inner",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "title",
                                        children: "Respect the Rights"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "text",
                                        children: [
                                            "R인증의 R은 교육자의 저작권과 학생의 학습권 모두를 존중하겠다는 의지를 표현한 Respect the Rights에 반복되는 첫 글자입니다. ",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "R인증은 교재의 저작권(Right)을 바르게(Right) 이용함으로써 ",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "학생들에게 진정한(Right) 교육을 제공하는 의지와 실천을 의미합니다."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(SecondSection, {
                        children: [
                            /*#__PURE__*/ _jsx(SectionHeader, {
                                children: "R인증이 발급된 수업콘텐츠로 마음껏 활동하세요."
                            }),
                            /*#__PURE__*/ _jsx(StyledSlideWrap, {
                                children: /*#__PURE__*/ _jsx(AliceCarousel, {
                                    infinite: true,
                                    // mouseTracking
                                    items: renderItems
                                })
                            }),
                            /*#__PURE__*/ _jsxs(PublisherArea, {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "top",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "date",
                                                children: "쏠북과 함께하는 자료 저작자 (24년 05월 기준)"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text",
                                                children: "*쏠북 마켓 입점순"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Image, {
                                        src: "/static/assets/img-main-tea-v5.jpg",
                                        alt: "저작자 이미지",
                                        width: 3600,
                                        height: 5280
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CTASection, {
                children: /*#__PURE__*/ _jsx(Button, {
                    type: "primary",
                    onClick: ()=>{
                        if (authStore.isLoggedIn) {
                            onClick();
                        } else {
                            const loginModal = ()=>{
                                const modal = Modal.success({
                                    title: "로그인을 해주세요",
                                    content: "로그인페이지로 이동합니다.",
                                    okButtonProps: {
                                        style: {
                                            display: "none"
                                        }
                                    }
                                });
                                setTimeout(()=>{
                                    modal.destroy();
                                }, 800);
                            };
                            loginModal();
                            redirectToLogin();
                        }
                    },
                    children: "내가 만든 자료를 누군가 무단으로 쓰고 있다면?"
                })
            }),
            /*#__PURE__*/ _jsx(GenericPanelWithModal, {
                width: 1044,
                open: modalOpen,
                closeIcon: true,
                okButtonProps: {
                    style: {
                        display: "none"
                    }
                },
                okText: "",
                cancelText: "",
                onClose: ()=>{
                    action("onCancel")();
                    onClick();
                },
                onOk: ()=>{
                    onClick();
                    action("onOk")();
                },
                children: /*#__PURE__*/ _jsx(ProtectionReportFormWrapper, {
                    children: /*#__PURE__*/ _jsxs(HasContentsPopupWrapper, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "titleWrapper",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "popupTitle",
                                        children: "저작권 침해 신고"
                                    }),
                                    /*#__PURE__*/ _jsx(WarningOutlined, {
                                        className: "alertIcon"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "alertComment",
                                        children: "정확한 확인을 위해 모두 입력해주세요."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Panel, {
                                children: /*#__PURE__*/ _jsx(ProtectionReportForm, {
                                    name: "ProtectionReportForm",
                                    initialValues: initialValues,
                                    initialStatus: null,
                                    onSubmit: onSubmit,
                                    publisherOptions: publisherOptions,
                                    onSetImageFile: onSetImageFile,
                                    onSetPdfFile: onSetPdfFile
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
});
